export const truncatePriceTo2Decimals = (price: number) => {
  const re = new RegExp('^-?\\d+(?:.\\d{0,' + 2 + '})?');
  return (price.toString().match(re) || '0')[0];
};
